import React from "react";
import { useTeamLocale } from "./TeamLocaleContext";
import { useTeamAdminLiveOptional } from "./TeamAdminLiveContext";

const TeamAdminNotifications = () => {
  const { t } = useTeamLocale();
  const live = useTeamAdminLiveOptional();

  if (!live || live.notifications.length === 0) return null;

  const { notifications, dismissNotification, clearNotifications, openNotification } =
    live;

  return (
    <div
      className="team-admin-notifications"
      role="region"
      aria-label={t("dashboard.notification.regionAria")}
    >
      <div className="team-admin-notifications-header">
        <span>{t("dashboard.notification.title")}</span>
        <button type="button" className="team-admin-notifications-clear" onClick={clearNotifications}>
          {t("dashboard.notification.clearAll")}
        </button>
      </div>
      <ul className="team-admin-notifications-list">
        {notifications.map((n) => (
          <li key={n.id}>
            <button
              type="button"
              className="team-admin-notification"
              onClick={() => openNotification(n)}
            >
              <span className="team-admin-notification-text">{n.message}</span>
              <span className="team-admin-notification-action">
                {t("dashboard.notification.view")}
              </span>
            </button>
            <button
              type="button"
              className="team-admin-notification-dismiss"
              onClick={() => dismissNotification(n.id)}
              aria-label={t("dashboard.notification.dismiss")}
            >
              ×
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TeamAdminNotifications;
